"use client";

import type { KeyboardEvent, MouseEvent, ReactNode } from "react";

const isInteractiveTarget = (target: EventTarget | null) =>
  target instanceof HTMLElement &&
  (target.closest("a") || target.closest("[data-row-stop]"));

const mediaUrlOf = (target: EventTarget | null) =>
  target instanceof HTMLElement
    ? target.closest<HTMLElement>("[data-media-url]")?.dataset.mediaUrl
    : undefined;

const openMedia = (url: string) =>
  window.open(url, "_blank", "noopener,noreferrer");

/**
 * Opens a row's media when the row is clicked or activated from the keyboard,
 * unless the click or key press landed on a link or a `data-row-stop` element
 * inside it. One handler for every row carrying `data-media-url`, so the rows
 * themselves render on the server.
 */
export function OpenMediaRows({ children }: { children: ReactNode }) {
  const onClick = (event: MouseEvent) => {
    if (event.defaultPrevented || isInteractiveTarget(event.target)) return;
    const url = mediaUrlOf(event.target);
    if (url) openMedia(url);
  };
  const onKeyDown = (event: KeyboardEvent) => {
    if (isInteractiveTarget(event.target)) return;
    if (event.key !== " " && event.key !== "Enter") return;
    const url = mediaUrlOf(event.target);
    if (!url) return;
    event.preventDefault();
    openMedia(url);
  };
  return (
    <div className="contents" onClick={onClick} onKeyDown={onKeyDown}>
      {children}
    </div>
  );
}
